import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

//import { EqualValidatorDirective } from "../directives/equal-validator.directive";
import { HasAuthUserViewPermissionDirective } from "../directives/has-auth-user-view-permission.directive";
import { IsVisibleForAuthUserDirective } from "../directives/is-visible-for-auth-user.directive";
import { SafePipe } from "../pipes/safe.pipe";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        // common and shared components/directives/pipes between more than one module and components will be listed here.
        IsVisibleForAuthUserDirective,
        HasAuthUserViewPermissionDirective,
        //EqualValidatorDirective
        // Pipes
        SafePipe
    ],
    exports: [
        // common and shared components/directives/pipes between more than one module and components will be listed here.
        IsVisibleForAuthUserDirective,
        HasAuthUserViewPermissionDirective,
        //EqualValidatorDirective
        // Pipes
        SafePipe,

        //
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
    /* No providers here! Since they’ll be already provided in AppModule. */
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        // Forcing the whole app to use the returned providers from the AppModule only.
        return {
            ngModule: SharedModule,
            providers: [ /* All of your services here. It will hold the services needed by `itself`. */]
        };
    }
}
